import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image, Link } from '@react-pdf/renderer';
import LogoWithSlogan from '../../../../assets/images/LogoWithSlogan.png';
import PDFIconHome from '../../Assets/PDFIconHome.png';
import PDFIconMenu from '../../Assets/PDFIconMenu.png';
import PDFIconPinOutline from '../../Assets/PDFIconPinOutline.png';
import { Farm } from 'Context/types';
import { calculatePercentageOfValues, kFormatter } from 'Helpers/helpers';
import ReactPDFChart from 'react-pdf-charts';
import { Area, Bar, CartesianGrid, ComposedChart, LabelList, Legend, XAxis, YAxis } from 'recharts';

const summary_styles = StyleSheet.create({
  weather_overview_item_container: {
    width: '170px',
    marginBottom: 12,
    padding: 12,
    borderRadius: 16,
    backgroundColor: '#CCEEEA',
    color: '#000000',
    fontSize: 12,
    alignItems: 'center'
  },
  weather_overview_item: { flexDirection: 'row', width: '100%' },
  weather_overview_item_icon: { width: 16, marginRight: 4, padding: 2 }
});
export type SummaryPageProps = {
  left_header: string;
  left_subheader: string;
  center_header: string;
  center_subheader: string;
  week_no: number;
  styles: any;
  total_forecast: number;
  varieties_count: number;
  total_fields_count: number;
  active_fields_count: number;
  graph_data: any[];
};
const SummaryPage = (props: SummaryPageProps) => (
  <View style={props.styles.section} id="overall-farm-report">
    <View
      style={{
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '0%',
        marginRight: '2%'
      }}
    >
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between'
        }}
      >
        <View
          style={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Text
            style={{
              fontSize: '14px',
              marginBottom: 2,
              textAlign: 'center',
              fontWeight: 'medium'
            }}
          >
            {props.left_header}
          </Text>
          <Text
            style={{
              fontSize: '9px',
              marginBottom: 2,
              textAlign: 'center',
              fontWeight: 400
            }}
          >
            {props.left_subheader}
          </Text>
        </View>
        <View style={{ alignItems: 'center' }}>
          <Text
            style={{
              fontSize: '14px',
              marginBottom: 2,
              textAlign: 'center',
              fontWeight: 'medium'
            }}
          >
            {`${props.center_header}`}
          </Text>
          <Text
            style={{
              fontSize: '11px',
              marginBottom: 2,
              textAlign: 'center',
              fontWeight: 400
            }}
          >
            {props.center_subheader}
          </Text>
        </View>
        <View>
          <Image style={{ width: '90px', padding: '2px' }} src={LogoWithSlogan}></Image>
        </View>
      </View>
    </View>

    {/* summary cards section */}
    <View style={{ flexDirection: 'row', marginTop: 24 }}>
      {/* latest forecast */}
      <View
        style={{
          ...props.styles.info_card,
          backgroundColor: '#98C9FF'
        }}
      >
        <Text style={{ fontSize: 16, fontWeight: 'medium', marginBottom: 4, textAlign: 'left' }}>
          {props.total_forecast.toLocaleString()}
        </Text>
        <Text style={{ fontSize: 12, textAlign: 'left' }}>Lima Forecast</Text>
      </View>

      {/* total varieties */}
      <View
        style={{
          ...props.styles.info_card,
          backgroundColor: '#98C9FF'
        }}
      >
        <Text style={{ fontSize: 16, fontWeight: 'medium', marginBottom: 4 }}>
          {props.varieties_count}
        </Text>
        <Text style={{ fontSize: 12 }}>Variet{props.varieties_count == 1 ? 'y' : 'ies'}</Text>
      </View>

      {/* total fields */}
      <View
        style={{
          ...props.styles.info_card,
          backgroundColor: '#98C9FF'
        }}
      >
        <Text style={{ fontSize: 16, fontWeight: 'medium', marginBottom: 4 }}>
          {props.active_fields_count}
        </Text>
        <Text style={{ fontSize: 12 }}>
          Active Field{props.active_fields_count == 1 ? '' : 's'}
        </Text>
      </View>
      {/* 2 weeks out forecast */}
      <View
        style={{
          ...props.styles.info_card,
          backgroundColor: '#98C9FF'
        }}
      >
        <Text style={{ fontSize: 16, fontWeight: 'medium', marginBottom: 4 }}>
          {props.total_fields_count}
        </Text>
        <Text style={{ fontSize: 12 }}>Total Fields</Text>
      </View>
    </View>
    <View
      style={{
        marginTop: 40,
        marginLeft: 10,
        left: 0,
        paddingTop: 30,
        paddingBottom: 20,
        backgroundColor: '#ffffff',
        borderRadius: 6
      }}
    >
      <ReactPDFChart style={{ left: -30 }}>
        <ComposedChart
          width={750}
          height={250}
          data={props.graph_data}
          style={{ left: 0 }}
          barGap={4}
          margin={{ top: 30 }}
          // barSize={18}
        >
          <CartesianGrid strokeDasharray="0" vertical={false} />
          <XAxis dataKey="name" interval={0} tick={{ fontSize: 11, fontWeight: 'bold' }} />
          <YAxis
            tickCount={6}
            tickFormatter={(value: string) => value && kFormatter(Number(value), 1)}
            tick={{ fontSize: 11, fontWeight: 'bold' }}
          />
          <Legend iconType="circle" iconSize={10} width={830} align="left" />
          <Bar dataKey={'Actuals'} fill={'#626262'} isAnimationActive={false} radius={[3, 3, 0, 0]}>
            <LabelList
              dataKey="Actuals"
              position="top"
              formatter={(value: number) => kFormatter(value, 1) ?? ''}
              color="#000"
            />
          </Bar>
          <Bar
            dataKey={'Forecasts'}
            fill={'#53A5FF'}
            isAnimationActive={false}
            radius={[3, 3, 0, 0]}
          >
            <LabelList
              dataKey="Forecasts"
              position="top"
              formatter={(value: number) => kFormatter(value, 1) ?? ''}
              color="#000"
            />
          </Bar>
        </ComposedChart>
      </ReactPDFChart>
    </View>
  </View>
);

export default SummaryPage;
